import moment from "moment";
import { Pricing } from "@/shared/interfaces/pricing/pricing.interface";

require("moment/locale/fr");
require("moment/locale/nl");

export const MILLISECONDS_PER_MINUTES = 1000 * 60;
export const MILLISECONDS_PER_DAY = MILLISECONDS_PER_MINUTES * 60 * 24;

/**
 * Format a date in the given locale.
 */
export function formatDate(dateString: string, locale: string): string {
    moment.locale(locale);

    let formatString = "MM/DD/YYYY";

    switch (locale) {
    case "fr":
    case "nl":
        formatString = "DD/MM/YYYY";
        break;
    case "en":
        formatString = "MM/DD/YYYY";
        break;
    }

    return moment(dateString).format(formatString);
}

/**
 * Calculate difference between 2 dates in days.
 *
 * @param ignoreTimeOfDay {boolean=true}
 */
export function daysBetween(date: Date, furtherDate: Date, ignoreTimeOfDay = true): number {
    if (!ignoreTimeOfDay) {
        return (furtherDate.getTime() - date.getTime()) / MILLISECONDS_PER_DAY;
    }

    const one = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const two = new Date(furtherDate.getFullYear(), furtherDate.getMonth(), furtherDate.getDate());

    const diffInDays = (two.getTime() - one.getTime()) / MILLISECONDS_PER_DAY;

    return Math.ceil(diffInDays);
}

/**
 * Calculate difference between 2 dates in minutes.
 */
export function minutesBetween(date: Date, furtherDate: Date): number {
    return (furtherDate.getTime() - date.getTime()) / MILLISECONDS_PER_MINUTES;
}

/**
 * Converts a duration to days for chronological sorting.
 * Used to ensure durations like "2 weeks" appear before "1 month".
 */
export function getDurationInDays(pack: Pricing): number {
    const { unit, count } = pack.duration;
    switch (unit) {
    case "DAY": return count;
    case "WEEK": return count * 7;
    case "MONTH": return count * 30;
    case "YEAR": return count * 365;
    default: return count;
    }
}
